import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import { Box, Button, Grid, IconButton, InputLabel, MenuItem, Pagination, Select } from '@mui/material';
import { useNavigate } from 'react-router';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import SearchImg from '../../assets/search.svg';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import FieldData from './FieldData';
import BigFilter from 'src/components/inputs/BigFilter';
import { ClearIcon } from '@mui/x-date-pickers-pro';
import UpcomingInquiry from './components/UpcomingInquiry';
import * as XLSX from 'xlsx';
import { FaDownload } from "react-icons/fa";

const filterSourceOfEnquiry = [
  { label: 'Twitter', value: 'Twitter' },
  { label: 'Instagram', value: 'Instagram' },
  { label: 'Walking', value: 'Walking' },
  { label: 'Facebook', value: 'Facebook' },
  { label: 'Website', value: 'Website' },
];

const filterLeadStatus = [
  { label: 'Pending', value: 'Pending' },
  { label: 'Converted', value: 'Converted' },
  { label: 'Closed', value: 'Closed' },
];

const filterEnquiryType = [
  { label: 'Hot', value: 'Hot' },
  { label: 'Cold', value: 'Cold' },
  { label: 'Warm', value: 'Warm' },
];

const filterGenderWise = [
  { value: 'Female', label: 'Female' },
  { value: 'Male', label: 'Male' },
];

const AllEnquiry = () => {
  const { fetchAllEquiry, activeBranchId, setShowMessage, getBranch } = useMain();
  const [data, setData] = useState([]);
  const [checkedClientEnquiry, setCheckedClientEnquiry] = useState([]);
  const [showLoader, setShowLoader] = useState(true);
  const [search, setSearch] = useState('');
  const [genderBy, setGenderBy] = useState([]);
  const [sourceOfEnquiry, setSourceOfEnquiry] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [enquiryType, setEnquiryType] = useState([]);
  const [clear, setClear] = useState(false);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [filterData, setFilterData] = useState([]);
  const [hideDownloadButton, setHideDownloadButton] = useState(true);

  const navigate = useNavigate();

  const clearDataHandler = () => {
    setLimit(10);
    setPage(1);
    setSearch('');
    setSourceOfEnquiry([]);
    setLeadStatus([]);
    setEnquiryType([]);
    setGenderBy([]);
    getData();
    // if (clear) {
    //   getData('clear');
    //   setClear(false);
    // }
  };

  const onApplyHandler = () => {
    if (search) {
      getData();
      setClear(true);
    }
  };

  const getData = async (key) => {
    try {
      setShowLoader(true);
      const res = await fetchAllEquiry(activeBranchId);
      if (res.statusCode === 200) {
        setData(res?.data || []);
      } else {
        // Handle errors here
      }
      const branchRes = await getBranch(activeBranchId);
      if (branchRes.statusCode === 200) {
        setHideDownloadButton(branchRes?.data?.hideDownloadButton || false);
        // Handle errors here
      }
    } catch (error) {
      // Handle errors here
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    if (activeBranchId) {
      // setClear(true);
      getData();
    }
  }, [activeBranchId]);

  useEffect(() => {
    applyFilters();
  }, [limit, page, sourceOfEnquiry, enquiryType, leadStatus, genderBy, data, search]);

  // const applyFilters = () => {
  //   let filteredData = data.filter((item) => {
  //     let isGenderMatch = genderBy.length === 0 || genderBy.includes(item.gender);
  //     let isSourceMatch = sourceOfEnquiry.length === 0 || sourceOfEnquiry.includes(item.sourceOfEnquiry);
  //     let isTypeMatch = enquiryType.length === 0 || enquiryType.includes(item.enquiryType);
  //     let isStatusMatch = leadStatus.length === 0 || leadStatus.includes(item.leadStatus);
  //     let isNameMatch = !search || item.clientName.toLowerCase().includes(search.toLowerCase()) || item.clientNumber.includes(search);

  //     return isGenderMatch && isSourceMatch && isTypeMatch && isStatusMatch && isNameMatch;
  //   });

  //   // Applying pagination
  //   const startIndex = (page - 1) * limit;
  //   const endIndex = startIndex + limit;
  //   filteredData = filteredData.slice(startIndex, endIndex);
  //   setFilterData(filteredData);
  // };
        const fuzzyMatch = (text, search) => {
        if (!search) return true;
        const lowerText = String(text ?? '').toLowerCase().replace(/\s/g, '');
        if (!lowerText) return false;

        const lowerSearch = search.toLowerCase().replace(/\s/g, '');

        let textIndex = 0;
        let searchIndex = 0;
        while (textIndex < lowerText.length && searchIndex < lowerSearch.length) {
          if (lowerText[textIndex] === lowerSearch[searchIndex]) {
            searchIndex++;
          }
          textIndex++;
        }
        return searchIndex === lowerSearch.length;
      };
  const applyFilters = () => {
    let filteredData = data.filter((item) => {
      let isGenderMatch = genderBy.length === 0 || genderBy.includes(item.gender);
      let isSourceMatch = sourceOfEnquiry.length === 0 || sourceOfEnquiry.includes(item.sourceOfEnquiry);
      let isTypeMatch = enquiryType.length === 0 || enquiryType.includes(item.enquiryType);
      let isStatusMatch = leadStatus.length === 0 || leadStatus.includes(item.leadStatus);
      const searchTerm = search.trim();
      const looksLikeNumber = /^[+\d\s\-()]+$/.test(searchTerm) && /\d/.test(searchTerm);
      const digitsSearch = searchTerm.replace(/\D/g, '');

      let isNameMatch = !searchTerm
        ? true
        : looksLikeNumber
          ? String(item.clientNumber ?? '').replace(/\D/g, '').includes(digitsSearch)
          : fuzzyMatch(item.clientName, searchTerm);

      return isGenderMatch && isSourceMatch && isTypeMatch && isStatusMatch && isNameMatch;
    });

    setFilterData(filteredData);
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  // Remove only leading spaces while typing (spaces between words still work)
  const handleSearchChange = (e) => {
    setSearch(e.target.value.trimStart());
    setPage(1);
  };

  // Cleans pasted text, then inserts it at the cursor position
  const handleSearchPaste = (e) => {
    e.preventDefault();
    let pasted = e.clipboardData.getData('text').trim();

    // If it looks like a phone number, remove spaces, dashes, brackets and +91
    if (/^[+\d\s\-()]+$/.test(pasted)) {
      pasted = pasted.replace(/[\s\-()]/g, '').replace(/^\+?91(?=\d{10}$)/, '');
    }

    const { selectionStart, selectionEnd, value } = e.target;
    const next = (value.slice(0, selectionStart) + pasted + value.slice(selectionEnd)).trim();
    setSearch(next);
    setPage(1);
  };

  // Trims trailing spaces when the user leaves the box
  const handleSearchBlur = (e) => {
    const trimmed = e.target.value.trim();
    if (trimmed !== e.target.value) {
      setSearch(trimmed);
    }
  };

  const handleExport = () => {
    if (filterData.length === 0) {
      setShowMessage({ message: 'No data found to export', messageType: 'info' });
      return;
    }

    const exportData = filterData.map((item) => ({
      'Client Name': item.clientName,
      'Contact Number': item.clientNumber,
      'Gender': item.gender,
      'Age': item.age || '-',
      'Email': item.email || '-',
      'Address': item.address || '-',
      'Follow-up Date': item.dateOfFollow ? new Date(item.dateOfFollow).toLocaleDateString('en-GB') : '-',
      'Enquiry Type': item.enquiryType,
      'Lead Status': item.leadStatus,
      'Enquiry For': item.enquiryFor,
      'Source Of Enquiry': item.sourceOfEnquiry,
      'Lead Representative': item.leadRepresentative || '-',
      'Response': item.clientResponse && Array.isArray(item.clientResponse) ? item.clientResponse.join(' | ') : '-',
      'Reference': item.reference || '-',
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Enquiries');
    XLSX.writeFile(wb, `Client_Enquiries_${new Date().toLocaleDateString('en-GB').replace(/\//g, '-')}.xlsx`);
  };

  const totalPages = Math.ceil(filterData.length / limit);

  return (
   <PageContainer title="All Enquiries" description="This contains all Enquiries">
  <DashboardCard2 title="All Enquiries">
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      marginBottom: '1.7rem',
    }}>
      {/* Left side - Show per page */}
      <div>
        <InputLabel>Show per page</InputLabel>
        <Select
          style={{
            borderRadius: '7px',
            border: '0.5px solid #6174DD',
            padding: '4px 12px',
            background: '#FFF',
            height: '40px',
            width: '100px'
          }}
          value={limit}
          onChange={handleLimitChange}
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={20}>20</MenuItem>
          <MenuItem value={50}>50</MenuItem>
          <MenuItem value={1000000}>All</MenuItem>
        </Select>
      </div>

      {/* Right side - Search, Filter and Client Reviews button */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'flex-end', 
        gap: '0.8rem'
      }}>
        {/* Search */}
        <div style={{ width: '170px', flexShrink: 0 }} onClick={() => document.getElementById('search-input').focus()}>
          <InputLabel>Search</InputLabel>
          <div 
            className="search-input" 
            style={{ 
              display: 'flex', 
              alignItems: 'center',
              border: '0.5px solid #6174DD',
              borderRadius: '7px',
              padding: '4px 12px',
              background: '#FFF',
              height: '40px',
              width: '100%',
              maxWidth: 'none',
              boxSizing: 'border-box'
            }}
          >
            <img src={SearchImg} alt="" style={{ marginRight: '8px' }} />
            <input
              id="search-input"
              type="text"
              placeholder="Search Enquiries..."
              value={search}
              onChange={handleSearchChange}
              onPaste={handleSearchPaste}
              onBlur={handleSearchBlur}
              style={{ 
                flex: 1, 
                border: 'none', 
                outline: 'none',
                background: 'transparent'
              }}
            />
            {search && (
              <IconButton
                onClick={() => setSearch('')}
                style={{ padding: 1 }}
              >
                <ClearIcon style={{
                  color: '#000',
                  fontSize: '1.1rem'
                }} />
              </IconButton>
            )}
          </div>
        </div>

        {/* Filter */}
        <div>
          <BigFilter
            options={[
              { title: 'Gender', items: filterGenderWise },
              { title: 'Source of Enquiry', items: filterSourceOfEnquiry },
              { title: 'Lead Status', items: filterLeadStatus },
              { title: 'Enquiry Type', items: filterEnquiryType },
            ]}
            value={[...genderBy, ...sourceOfEnquiry, ...leadStatus, ...enquiryType]}
            onChange={(selectedValues) => {
              setGenderBy(selectedValues.filter(val => filterGenderWise.some(opt => opt.value === val)));
              setSourceOfEnquiry(selectedValues.filter(val => filterSourceOfEnquiry.some(opt => opt.value === val)));
              setLeadStatus(selectedValues.filter(val => filterLeadStatus.some(opt => opt.value === val)));
              setEnquiryType(selectedValues.filter(val => filterEnquiryType.some(opt => opt.value === val)));
            }}
            placeholder="Filters"
          />
        </div>

        {/* Export Button */}
        {!hideDownloadButton && (
          <div style={{ width: '70px' }}>
            <Button
              onClick={handleExport}
              variant="contained"
              color="primary"
              title="Download Enquiries"
              sx={{
                height: '40px',
                width: '100%',
                padding: '0.3rem',
                '&:hover': { background: '#6174DD' },
              }}
            >
              <FaDownload style={{ height: '1.6rem', fontSize: '1.2rem' }} />
            </Button>
          </div>
        )}

        {/* Client Reviews Button */}
        <div>
          <Button
            onClick={() => navigate('/clientReview')}
            variant="contained"
            color="primary"
            sx={{
              background: '#6174DD',
              height: '40px',
              minWidth: '140px'
            }}
          >
            Client Reviews
          </Button>
        </div>
      </div>
    </div>

    {showLoader ? (
      <ShowLoader />
    ) : (
      <>
        <UpcomingInquiry data={data} />
        {filterData.length > 0 ? (
          <Box>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <FieldData
                  data={filterData.slice((page - 1) * limit, page * limit)}
                  setData={setData}
                  getData={getData}
                  checkedClientEnquiry={checkedClientEnquiry}
                  setCheckedClientEnquiry={setCheckedClientEnquiry}
                  search={search.trim()}
                />
              </Grid>
            </Grid>
          </Box>
        ) : (
          'No data found'
        )}
      </>
    )}
    <Box display={'flex'} justifyContent={'flex-end'}>
      <Pagination
        count={totalPages}
        page={page}
        color="primary"
        onChange={(e, page) => setPage(page)}
      />
    </Box>
  </DashboardCard2>
</PageContainer>
  );
};

export default AllEnquiry;
